// Turn any Axios error / FastAPI validation response into a human-readable string.
// FastAPI returns `{detail: string}` for HTTPException and `{detail: [FieldError, ...]}`
// for Pydantic validation failures. Naively rendering the latter as JSX crashes React
// with "Objects are not valid as a React child" (React #31).
export function formatApiError(err, fallback = "Something went wrong") {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string" && detail) return detail;
  if (Array.isArray(detail)) {
    const parts = detail.slice(0, 4).map((d) => {
      // Skip the "body" prefix and any "rows" wrapper; keep row index + field name
      const loc = Array.isArray(d?.loc) ? d.loc.filter((x) => x !== "body") : [];
      // e.g. ["rows", 3, "belt"] → "row 3 · belt"
      const rowIdx = loc.find((x) => typeof x === "number");
      const field = loc[loc.length - 1];
      const where = rowIdx != null ? `row ${rowIdx + 2}` : "input"; // +2 because CSV row 1 is header
      const what = field && field !== rowIdx ? ` · ${field}` : "";
      const msg = d?.msg || d?.type || "invalid value";
      return `${where}${what}: ${msg}`;
    });
    if (parts.length === 0) return fallback;
    return detail.length > 4 ? `${parts.join(" · ")} …and ${detail.length - 4} more` : parts.join(" · ");
  }
  if (err?.message) return err.message;
  return fallback;
}
